import React, { useMemo } from 'react'
import useApiService from 'services/api'
import LoadingScreen from 'components/Layout/LoadingScreen'
import {
  CompanyPageLayout,
  CompanyContentSections,
} from 'components/NewCompanyPage'
import { UnmatchedDoorsModal } from 'components/NewCompanyPage/Modals/UnmatchedDoorsModal'
import useDocumentTitle from 'components/useDocumentTitle'
import { buildNursingHomePageContent } from './companyTypeData'

export function NewNursingHomePage({
  nursingHomeID,
}: {
  nursingHomeID?: number
}) {
  const api = useApiService()
  const { data, isLoading } = api.useGetNursingHome(nursingHomeID)

  const [showDoorsModal, setShowDoorsModal] = React.useState(false)

  // Shared derivation — identical stats/fields are reused by MobileNursingHomePage.
  const content = buildNursingHomePageContent(data, {
    onViewDoors: () => setShowDoorsModal(true),
  })

  useDocumentTitle(isLoading ? 'Loading...' : content.documentTitle)

  const entityBreadcrumbs = useMemo(
    () =>
      content.header.name
        ? [{ title: 'Company', label: content.header.name }]
        : [],
    [content.header.name]
  )

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <>
      <CompanyPageLayout
        chainProxyId={data!.id!}
        breadcrumbRoot={content.breadcrumbRoot}
        breadcrumbs={[
          {
            title: content.breadcrumbTitle,
            breadcrumb: content.header.name,
            url: undefined,
          },
        ]}
        entityBreadcrumbs={entityBreadcrumbs}
        categoryInfo={content.categoryInfo}
        sidebar={{
          header: {
            name: content.header.name,
            domain: content.header.domain ?? '',
            logoUrl: content.header.logoUrl,
          },
          tabs: [
            {
              key: 'summary',
              title: 'Summary',
              content: content.summaryContent,
            },
            {
              key: 'location-details',
              title: 'Location Details',
              content: content.locationDetailsContent,
            },
          ],
        }}
      >
        <CompanyContentSections
          chainProxyId={data!.id!}
          entityID={nursingHomeID}
          companyName={content.header.name}
          websiteAddress={content.header.domain ?? ''}
          companyTypeSlug={content.companyTypeSlug}
          tableTypeSlug={content.tableTypeSlug}
        />
      </CompanyPageLayout>

      {/* Unmatched Doors Modal */}
      {data && (
        <UnmatchedDoorsModal
          show={showDoorsModal}
          onHide={() => setShowDoorsModal(false)}
          forChainProxyId={data.id}
          chainData={{
            id: data.id,
            name: content.header.name,
            domain: content.header.domain,
          }}
          subCategory={content.modalSubCategory}
          companyName={content.header.name}
        />
      )}
    </>
  )
}
